import React, {useEffect, useState} from 'react';
import {connect, useDispatch} from "react-redux";
import Loader from "./layout/loading/loader";
import {Formik} from "formik";
import './UsersNewOrEdit.css'
import {number, object, string} from 'yup';
import {Container} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {useParams} from "react-router-dom";
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import SubmitButton from "./layout/forms/SubmitButton";
import {problemsActions} from "../../modules/problems/problems.actions";
import ProblemDataField from "./problems/form/ProblemDataField";
import {Engineering} from "@mui/icons-material";
import PageTitle from "./layout/PageTitle";
import Constants from "../../utils/constants";


const problemValidationSchema = object({
    libelle: string()
        .required("Le libellé est requis")
        .max(255, 'Le libellé ne doit pas dépasser 255 caractères'),
    libelleAr: string()
        .max(255, 'Le libellé ne doit pas dépasser 255 caractères')
        .nullable(),
    importance: number().required("Le degré d'importance est requis"),
    conteneurType: string().required('Le type de conteneur est requis')
});

function ProblemsNewOrEdit({...props}) {
    const dispatch = useDispatch();
    const params = useParams();
    const [mode, setMode] = useState("create");
    const [problemId, setProblemId] = useState(null);

    useEffect(() => {
        if (params.hasOwnProperty("id")) {
            setMode("edit");
            setProblemId(params.id);
        } else {
            setMode("create");
            setProblemId(null);
        }
    }, [params]);

    useEffect(() => {
        if (problemId && (props.problem?.id !== parseInt(problemId)) && !props.loading && !props.error) {
            dispatch(problemsActions.fetchProblem(problemId));
        }
    }, [props, dispatch, params.type, problemId]);


    const handleSubmit = (values) => {
        const payload = {...values, libelleAr: values.libelleAr?.trim() || null};
        if (mode === "create") {
            dispatch(problemsActions.createProblem(payload));
        } else {
            dispatch(problemsActions.updateProblem(payload, payload.id));
        }
    }

    const initialValues = {
        id: props.problem?.id ?? null,
        libelle: props.problem?.libelle ?? '',
        libelleAr: props.problem?.libelleAr ?? '',
        importance: props.problem?.importance ?? Constants.PROBLEMS_IMPORTANCE[0].code,
        conteneurType: props.problem?.conteneurType
    }

    if (props.loading) {
        return <Loader/>;
    }

    return (
        <>
            <PageTitle title={mode === "create" ? "Nouveau Problème" : "Modifier le problème"} icon={<Engineering/>}/>
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                validationSchema={problemValidationSchema}
                onSubmit={(values, {setSubmitting}) => {
                    handleSubmit(values)
                }}
            >
                {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      /* and other goodies */
                  }) => (
                    <form onSubmit={handleSubmit}>
                        <ProblemDataField values={values} errors={errors} handleChange={handleChange}
                                          handleBlur={handleBlur}/>

                        <Grid container size={12} justifyContent="center" style={{marginTop: '2rem'}}>
                            <Grid size={4}>
                                <SubmitButton submitting={isSubmitting && !props.error}/>
                            </Grid>
                        </Grid>
                    </form>
                )}
            </Formik>
        </>
    )
}

const mapStateToProps = function (state) {
    return {
        problem: state.problems.problem,
        loading: state.problems.loading,
        error: state.problems.error
    }
}

export default connect(mapStateToProps)(ProblemsNewOrEdit);
